module.exports = __webpack_public_path__ + "img/small-pic4.e7271429.png";